module.exports = __webpack_public_path__ + "img/z-adimg5-1.90ae4775.jpg";